<template>
  <div class="header">
      <div class="header-left">
        <p>木棉树智慧园区三维可视化</p>
        <span>MMS3D visualization of smart Park</span>
      </div>
      <div class="header-center">
        <div class="header-center-left">
          <div class="weather">
            <div v-for="(item,i) in weatherList" :key="i" class="weather-box">
              <P>{{item.text}}</P>
              <div class="box">
                <img class="box-bg" :src="item.bg">
                <span>{{item.num}}</span>
                <p>{{item.unit}}</p>
              </div>
            </div>
          </div>
          <div class="black" @click="black">
            <div class="ico"></div>
            <div class="ico-box"></div>
            <span>返回</span>
          </div>
        </div>
        <div class="header-center-right" v-show="$store.state.flag">
         <div class="list-box" v-for="(item,i) in list" :key="i" @click="chanageDay(i)">
           <img :class="item.flag?'ico active':'ico'" :src="item.ico">
           <div :class="item.flag?'ico-border active1':'ico-border'"></div>
           <p>{{item.text}}</p>
         </div>
        </div>
      </div>
    <div class="header-right">
      <div class="left">
        <div class="box-top">
          <span>{{week}}</span>
          <span>空气质量：良</span>
        </div>
        <div class="box-bottom">
          <span>{{year}}</span>
          <div class="weather">
            <img src="./../assets/weather-ico.png">
            <span>多云</span>
          </div>
        </div>
      </div>
      <div class="weather-border"></div>
      <div class="time">{{time}}</div>
    </div>
      <div class="header-border"></div>
  </div>
</template>

<script>
  import moment from "moment";
export default {
  name: 'Header',
  props:["nowPathName"],
  data () {
    return {
      weatherList: [
        {
          bg: require('./../assets/temperature-ico.png'),
          text: '温度',
          num: '16',
          unit: '℃'
        },
        {
          bg: require('./../assets/humidity-ico.png'),
          text: '湿度',
          num: '16',
          unit: '%'
        },
        {
          bg: require('./../assets/PM2.5-ico.png'),
          text: 'PM2.5',
          num: '16',
          unit: '%'
        },
        {
          bg: require('./../assets/noise-ico.png'),
          text: '噪音',
          num: '16',
          unit: 'fb'
        },
        {
          bg: require('./../assets/wind-ico.png'),
          text: '风速',
          num: '16',
          unit: 'min/s'
        }
      ],
      list:[
        {
          ico:require('./../assets/day-active.png'),
          text:'白天',
          flag:true,
          icoFalse:require('./../assets/day.png'),
          icoTrue:require('./../assets/day-active.png'),
        },
        {
          ico:require('./../assets/dusk.png'),
          text:'黄昏',
          flag:false,
          icoFalse:require('./../assets/dusk.png'),
          icoTrue:require('./../assets/dusk-active.png'),
        },
        {
          ico:require('./../assets/evening.png'),
          text:'夜晚',
          flag:false,
          icoFalse:require('./../assets/evening.png'),
          icoTrue:require('./../assets/evening-active.png'),
        }
      ],
      year:'',
      time:'',
      week:''
    }
  },
  mounted() {
      setInterval(()=>{
          for(let i = 0; i < this.weatherList.length;i++){
            this.weatherList[i].num = this.changeNum();
          }
      },5000)
  },
  methods:{
    black(){
     if( typeof window.devHandle === 'function' ){
       window.devHandle(-1)
     }
      window.recovery()
      document.getElementById('iframe').contentWindow.MMAPI.hide()
      document.getElementById('iframe').contentWindow.MMAPI.district(5);

      if(this.nowPathName=='parkOver'){

      }else if(this.nowPathName=='parkEnergy'){
        window.parkenergyViewCancel();
      }else if(this.nowPathName=='parkSecurity'){

        window.parkSecurityViewCancel();
      }else if(this.nowPathName=='deviceManagement'){
        window.deviceManagementViewCincle();
      }
    },
    chanageDay(num){
      for(let i = 0;i < this.list.length;i++){
        if(num==i){
          this.list[i].flag = true
        }else {
          this.list[i].flag = false;
        }
      }
      for(let i = 0;i < this.list.length;i++){
        if(this.list[i].flag){
          this.list[i].ico = this.list[i].icoTrue
        }else {
          this.list[i].ico = this.list[i].icoFalse
        }
      }
     if(this.nowPathName=='deviceManagement'){

     }else {

       document.getElementById('iframe').contentWindow.MMAPI.sceneQH(num)
     }
    },
    changeNum(){
      return Math.floor(Math.random()*(100-1)+1)
    }
  },
  created() {
    setInterval(() => {
      this.year = moment().format(`YYYY.MM.DD`);
      this.time = moment().format(`HH:mm:ss`);
      let d = moment().format(`d`);

      switch (d) {
        case '0':
          this.week = '周日'
          break;
        case '1':
          this.week = '周一'
          break;
        case '2':
          this.week = '周二'
          break;
        case '3':
          this.week = '周三'
          break;
        case '4':
          this.week = '周四'
          break;
        case '5':
          this.week = '周五'
          break;
        case '6':
          this.week = '周六'
          break;
      }
    }, 1000);
  }
}
</script>

<style scoped lang="less">
  .header{
    color: #fff;
    font-size: 12px;
    height: 72vh*0.108;
    margin: 0 27px;
    box-sizing: border-box;
    position: relative;
    z-index: 9;
    .header-border{
      position: absolute;
      background: url("./../assets/header-border.png") no-repeat;
      background-size: 100% 100%;
      width: 1865px;
      height: 47vh*0.0926;
      bottom: 0;
    }
    .header-left{
      position: absolute;
      left: 0;
      bottom: 10vh*0.0926;
      font-family: rzzy;
      p{
        font-size: 32px;
        color: #fff;
      }
      span{
        font-size: 16.47px;
        color: #ffab51;
      }
    }
    .header-center{
      width: 1018px;
      position: absolute;
      height: 50px;
      bottom: -20vh*0.0926;
      left: 25%;
      display: flex;
      justify-content: space-between;
      z-index: 999;
      .header-center-left{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;
        .weather{
          background: url("./../assets/header-function.png") no-repeat;
          background-size: 100% 100%;
          width: 378px;
          height: 36px;
          display: flex;
          justify-content: space-around;
          box-sizing: border-box;
          .weather-box{
            font-size: 12px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            p{
              color: #cbcbcb;
            }
            .box{
              display: flex;
              color: #ffffff;
              align-items: flex-end;
              .box-bg{

              }
              span{
                font-weight: bold;
              }
              p{
                transform: scale(0.7);
              }
            }
          }
        }
        .black{
          height: 100%;
          display: flex;
          flex-direction: column;
          position: relative;
          align-items: center;
          margin-left: 35px;
          cursor: pointer;
          .ico{
            background: url("./../assets/black.png") no-repeat;
            background-size: 100% 100%;
            width: 28px;
            height: 28px;
          }
          .ico-box{
            background: url("./../assets/black-bottom.png") no-repeat;
            background-size: 100% 100%;
            width: 58px;
            height: 27px;
            position: absolute;
            top: 15px;
          }
          span{
            font-size: 12px;
            color: #fff;
            position: absolute;
            bottom: -10px;/*no*/
          }
        }
      }
      .header-center-right{
        display: flex;
        .list-box{
          margin-left: 60px;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          width: 68px;
          height: 100%;
          cursor: pointer;
          &:nth-of-type(1){
           .ico{
             width: 24px;
             height: 24px;
             &.active{
               width: 40px;
               height: 40px;
               top: -12px;
             }
           }
          }
          &:nth-of-type(2){
            .ico{
              width: 22px;
              height: 21px;
              &.active{
                width: 39px;
                height: 39px;
                top: -11px;
              }
            }
          }
          &:nth-of-type(3){
            .ico{
              width: 20px;
              height: 24px;
              &.active{
                width: 36px;
                height: 41px;
                top: -12px;
              }
            }
          }
          .ico{
            position: absolute;
            bottom: 30px;
          }
          .ico-border{
            position: absolute;
            background: url("./../assets/weather-bottom.png") no-repeat;
            background-size: 100% 100%;
            width: 68px;
            height: 36px;
            top: 10px;
           &.active1{
             background: url("./../assets/weather-bottom-active.png") no-repeat;
           }
          }

          p{
            position: absolute;
            bottom: 0;
          }
        }
      }
    }
    .header-right{
      position: absolute;
      right: 0;
      display: flex;
      margin-top: 22vh*0.108;
      height: 33vh*0.108;
      .left{
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .box-top{
          span{
            &:nth-of-type(1){
              margin-right: 25px;
            }
          }
        }
        .box-bottom{
          display: flex;
          justify-content: space-between;
          .weather{
            display: flex;
          }
        }
      }
      .weather-border{
        background: url("./../assets/weather-border.png") no-repeat;
        background-size: 100% 100%;
        height: 37px;/*no*/
        width: 2px;/*no*/
        margin: 0 8px;/*no*/
      }
      .time{
        font-size: 30.13px;
        font-weight: bold;
      }
    }
  }
</style>
